import { Type, type Static } from "typebox";

/** Product apps only (no Platform), same relative order as SUITE_PRODUCT_ORDER. */
export const PRODUCT_KEYS = ["source", "codify", "function", "radius"] as const;
export const ProductKeySchema = Type.Union([
  Type.Literal("source"),
  Type.Literal("codify"),
  Type.Literal("function"),
  Type.Literal("radius"),
]);
export type ProductKey = (typeof PRODUCT_KEYS)[number];

export const OrganizationRoleSchema = Type.Union([
  Type.Literal("owner"), Type.Literal("admin"), Type.Literal("member"),
]);
export type OrganizationRole = Static<typeof OrganizationRoleSchema>;

export const SuiteIdentityV1Schema = Type.Object({
  version: Type.Literal(1),
  sessionId: Type.String({ format: "uuid" }),
  sessionEpoch: Type.Integer({ minimum: 0 }),
  product: ProductKeySchema,
  userId: Type.String({ format: "uuid" }),
  workosUserId: Type.String({ minLength: 1, maxLength: 255 }),
  organizationId: Type.String({ format: "uuid" }),
  workosOrganizationId: Type.String({ minLength: 1, maxLength: 255 }),
  organizationRole: OrganizationRoleSchema,
  suiteStatus: Type.Union([Type.Literal("entitled"), Type.Literal("grace")]),
  expiresAt: Type.String({ format: "date-time" }),
}, { additionalProperties: false });
export type SuiteIdentityV1 = Static<typeof SuiteIdentityV1Schema>;

export const PlatformIdentityV1Schema = Type.Object({
  version: Type.Literal(1),
  platformSessionId: Type.String({ format: "uuid" }),
  sessionEpoch: Type.Integer({ minimum: 0 }),
  userId: Type.String({ format: "uuid" }),
  workosUserId: Type.String({ minLength: 1, maxLength: 255 }),
  activeOrganizationId: Type.Union([Type.String({ format: "uuid" }), Type.Null()]),
  activeWorkosOrganizationId: Type.Union([Type.String({ minLength: 1 }), Type.Null()]),
  organizationRole: Type.Union([OrganizationRoleSchema, Type.Null()]),
  isF5Admin: Type.Boolean(),
  expiresAt: Type.String({ format: "date-time" }),
}, { additionalProperties: false });
export type PlatformIdentityV1 = Static<typeof PlatformIdentityV1Schema>;
